import { GetServerSideProps } from 'next'

import Container from '@/components/Container/Container'
import { ExplicitHead } from '@/components/DefaultHead/DefaultHead'
import Main from '@/components/Main/Main'
import SimpleHeader from '@/components/SimpleHeader/SimpleHeader'
import SubNav from '@/components/SubNav/SubNav'
import SubNavSearch from '@/components/SubNavSearch/SubNavSearch'
import { SetType } from '@/store/misc/initialState'
import { serverSidePropsFor } from '@/utils/helpers.server'

type Props = {
  data: {
    data: SetType[]
  }
}

const SetsPage = ({ data }: Props) => {
  return (
    <Main>
      <ExplicitHead
        description='Recent MTG sets and their top cards for Commander.'
        keywords='sets,editions,commander,edh'
        title='All Sets | EDHREC'
      />
      <Container>
        <SimpleHeader className='mb-1'>All Sets</SimpleHeader>
        <SubNavSearch />
        <SubNav
          grid
          items={data.data.map(({ code, icon_svg_uri, name }) => ({
            ...(icon_svg_uri && { image: <img alt={code} className='set-icon' src={icon_svg_uri} /> }),
            textLeft: name,
            url: `/sets/${code}`,
          }))}
        />
      </Container>
    </Main>
  )
}

export const getServerSideProps: GetServerSideProps<Props> = async ({ req }) =>
  serverSidePropsFor(`${process.env.NEXT_PUBLIC_EDHREC_JSON_URL}/static/sets`, req.headers)

export default SetsPage
